import styled from 'styled-components';
import { breakpoints } from '@/theme';
export const StyledFrameContent = styled.main `
  width: 100%;
  display: flex;
  height: 100%;

  @media (max-width: ${breakpoints.sm}px) {
    top: ${({ theme }) => theme.appHeader.heightMobile};
    height: calc(100vh - ${({ theme }) => theme.appHeader.heightMobile});
  }

  @media (max-width: ${breakpoints.xs}px) {
    top: ${({ theme }) => theme.appHeader.heightXSMobile};
    height: calc(100vh - ${({ theme }) => theme.appHeader.heightXSMobile});
  }

  #ui-toggle-collapse-button {
    left: ${({ theme }) => theme.typography.pxToRem(225)};
  }
`;
